const initSaleBannerCta = () => {
  const $saleBanner = document.querySelector(".sale-banner--clickable");
  const $cta = document.querySelector(".js-sale-banner-cta");

  if (!($saleBanner && $cta)) {
    return;
  }

  $saleBanner.addEventListener("mouseenter", () => {
    $cta.classList.add("sale-banner__cta--active");
  });

  $saleBanner.addEventListener("mouseleave", () => {
    $cta.classList.remove("sale-banner__cta--active");
  });

  $saleBanner.addEventListener("mousemove", (e) => {
    $cta.style.left = `${e.clientX}px`;
    $cta.style.top = `${e.clientY}px`;
  });
};

initSaleBannerCta();
